import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36ad0c29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-6 mt-6 border-b-2 border-black-header" }
const _hoisted_2 = {
  class: "nav nav-tabs",
  id: "nav-tab"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center\" data-v-36ad0c29><span class=\"xr-all-net mr-2\" data-v-36ad0c29><span class=\"path1\" data-v-36ad0c29></span><span class=\"path2\" data-v-36ad0c29></span><span class=\"path3\" data-v-36ad0c29></span><span class=\"path4\" data-v-36ad0c29></span></span><span data-v-36ad0c29> All Games </span></div>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-test-net mr-2\" data-v-36ad0c29><span class=\"path1\" data-v-36ad0c29></span><span class=\"path2\" data-v-36ad0c29></span><span class=\"path3\" data-v-36ad0c29></span><span class=\"path4\" data-v-36ad0c29></span></span>", 1)
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-main-net mr-2\" data-v-36ad0c29><span class=\"path1\" data-v-36ad0c29></span><span class=\"path2\" data-v-36ad0c29></span><span class=\"path3\" data-v-36ad0c29></span><span class=\"path4\" data-v-36ad0c29></span></span>", 1)
const _hoisted_9 = {
  key: 0,
  class: "items-center flex p-6 pt-6"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-3 w-3 mr-3 bg-yellow-500 inline-block",
  viewBox: "0 0 24 24"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-sm" }, "Loading...", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "md:grid 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 p-3 pt-6 pb-0 overflow-hidden"
}
const _hoisted_15 = { class: "mx-3 mb-6" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-3xl" }, " + "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Add New Game")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "md:grid 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 p-3 pt-6 pb-0 overflow-hidden"
}
const _hoisted_19 = {
  key: 0,
  class: "mx-3 mb-6 text-gray-text text-sm"
}
const _hoisted_20 = {
  key: 2,
  class: "md:grid 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 p-3 pt-6 pb-0 overflow-hidden"
}
const _hoisted_21 = {
  key: 0,
  class: "mx-3 mb-6 text-gray-text text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gamesListGameBoxComponent = _resolveComponent("gamesListGameBoxComponent")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(["text-gray-text active py-2 px-4", _ctx.currentTab=='all'?'bg-black-header':'cursor-pointer']),
          id: "nav-details-tab",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentTab = 'all'))
        }, _hoisted_4, 2),
        _createElementVNode("button", {
          class: _normalizeClass(["text-gray-text active py-2 px-4", _ctx.currentTab=='testnet'?'bg-black-header':'cursor-pointer']),
          id: "nav-details-tab",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentTab = 'testnet'))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.testnetLabel), 1)
          ])
        ], 2),
        (_ctx.userData.mainnetWalletAddress)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["text-gray-text active py-2 px-4 ml-2", _ctx.currentTab=='mainnet'?'bg-black-header':'cursor-pointer']),
              id: "nav-details-tab",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentTab = 'mainnet'))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(_ctx.mainnetLabel), 1)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
      : _createCommentVNode("", true),
    (!_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_ctx.currentTab == 'all')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.gameId,
                    class: "mx-3 mb-6"
                  }, [
                    _createVNode(_component_gamesListGameBoxComponent, {
                      item: item,
                      mainnetGameTitles: _ctx.mainnetGameTitles,
                      network: "testnet"
                    }, null, 8, ["item", "mainnetGameTitles"])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCreateGameModal && _ctx.openCreateGameModal(...args)), ["prevent"])),
                    class: "border-black-ori border-2 border-dashed rounded-sm shadow-xl p-3 flex items-center justify-center text-white h-52 lg:h-full",
                    to: "create-game",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modalCreateGame"
                  }, _hoisted_17)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentTab == 'testnet')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testnetGames, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.gameId,
                    class: "mx-3 mb-6"
                  }, [
                    _createVNode(_component_gamesListGameBoxComponent, {
                      item: item,
                      mainnetGameTitles: _ctx.mainnetGameTitles,
                      network: "testnet"
                    }, null, 8, ["item", "mainnetGameTitles"])
                  ]))
                }), 128)),
                (_ctx.testnetGames.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "No game released in " + _toDisplayString(_ctx.testnetLabel) + " yet", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentTab == 'mainnet')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainnetGames, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.gameId,
                    class: "mx-3 mb-6"
                  }, [
                    _createVNode(_component_gamesListGameBoxComponent, {
                      item: item,
                      mainnetGameTitles: _ctx.mainnetGameTitles,
                      network: "mainnet"
                    }, null, 8, ["item", "mainnetGameTitles"])
                  ]))
                }), 128)),
                (_ctx.mainnetGames.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "No game released in " + _toDisplayString(_ctx.mainnetLabel) + " yet", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}